<af-main-container [title]="'i18n_af_titleIncidentResolution' | translate"
                   [customLastBreadcrumb]="('i18n_lib_breadcrumb#IncidentId' | translate:{incidentId: incidentId})"
                   [specialFilter]="filterIncidentIdPath">

    @if (form) {
        <div class="container w-100" fxLayout="column" fxLayoutAlign="start start">
            <div class="details-container w-100" fxLayout="column" fxLayoutAlign="start start">
                <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 p-24 mt-24"
                      (submit)="createResolution()"
                      (keydown.control.enter)="createResolution()">
                    <div class="grid-form-container">
                        <af-dictionary-selector [dictionary]="resolutionStatusDictionary"
                                                [control]="form.controls.resolutionStatus"
                                                label="i18n_af_labelResolutionStatus"
                                                placeholder="i18n_af_placeholderSelectResolutionStatus"/>
                        <af-dictionary-selector dictionaryName="bin"
                                                [control]="form.controls.govOrganization"
                                                [filterDictionaryBy]="['IO']"
                                                [predefinedValue]="form.controls.govOrganization.value"
                                                [disabled]="true"
                                                label="i18n_af_labelGovernmentOrganization"
                                                placeholder="i18n_af_placeholderSelectGovernmentOrganization"/>
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelInvestigatorFullName' | translate }}{{ form.controls.investigatorFullName.hasValidator(Validators.required) ? ' *' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.investigatorFullName.value">
                                <input matInput
                                       formControlName="investigatorFullName"
                                       [placeholder]="'i18n_af_placeholderInvestigatorFullName' | translate"
                                       name="fullName"/>
                                @if (form.controls.investigatorFullName.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.investigatorFullName.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <af-phone-number #phoneNumberComponent
                                         [control]="form.controls.phoneNumber"
                                         [predefinedValue]="form.controls.phoneNumber.value"
                                         label="i18n_af_labelInvestigatorPhoneNumber"/>
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div
                                class="t5 c-primary-gray-600">{{ 'i18n_af_labelUnifiedRegisterNumber' | translate }}{{ form.controls.unifiedRegisterNumber.hasValidator(Validators.required) ? ' *' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.unifiedRegisterNumber">
                                <input matInput
                                       formControlName="unifiedRegisterNumber"
                                       [attr.maxlength]="UNIFIED_REGISTER_MAX_LENGTH"
                                       inputmode="numeric"
                                       (input)="onUnifiedRegisterNumberInput($event)"
                                       [placeholder]="'i18n_af_placeholderUnifiedRegisterNumber' | translate"
                                       name="unifiedRegisterNumber"/>
                                @if (form.controls.unifiedRegisterNumber.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.unifiedRegisterNumber.hasError('pattern')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationUnifiedRegisterNumber' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                        @if (form.controls.unifiedRegisterDate) {
                            <af-date-picker-field
                                labelTranslationKey="i18n_af_labelUnifiedRegisterDate"
                                placeholderTranslationKey="i18n_af_placeholderUnifiedRegisterDate"
                                [form]="form.controls.unifiedRegisterDate"
                                [minDate]="null"
                                [dateFormats]="DATE_FORMATS"
                                [supportedDateFormat]="['DDMMYYYY','DD.MM.YYYY']"/>
                        }
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-824 mt-24">
                        <div
                            class="t5 c-primary-gray-600">{{ 'i18n_af_labelResolutionDescription' | translate }}{{ form.controls.resolutionDescription.hasValidator(Validators.required) ? '*' : '' }}
                        </div>
                        <mat-form-field class="mt-4 w-100"
                                        [class.value-not-empty]="form.value.resolutionDescription">
          <textarea matInput
                    #descriptionArea
                    maxlength="{{DESCRIPTION_MAX_LENGTH}}"
                    class="resize-none pt-12 pb-12"
                    [placeholder]="'i18n_af_placeholderResolutionDescription' | translate"
                    formControlName="resolutionDescription"></textarea>
                            <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}
                                / {{ DESCRIPTION_MAX_LENGTH }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    @if (form.controls.files) {
                        <af-files
                            class="w-824 mt-40"
                            dropZoneStyle="dark"
                            [excludeItemsWithCode1]="true"
                            [form]="form.controls.files"
                            [bucket]="BucketName.RESOLUTION_FILES"
                            [maxFileCount]="MAX_FILES_COUNT"
                        />
                    }

                    <ng-container *ngIf="subjects?.length">
                        <mat-panel-title class="no-wrap t2-semi-bold mt-24">{{ 'i18n_af_labelSolutionInfo' | translate }}</mat-panel-title>
                        <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                            <div class="grid-form-container mt-16">
                                @for (s of subjects; track s.identificationNumber; let i = $index) {
                                    <div fxLayout="column" fxLayoutAlign="start start">
                                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelSuspect' | translate }}</div>
                                        <mat-form-field class="w-100 mt-4" [class.value-not-empty]="true">
                                            <input matInput [readonly]="true" [value]=getParticipantDisplayValue(s)>
                                        </mat-form-field>
                                    </div>

                                    <div fxLayout="column" fxLayoutAlign="start start">
                                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelCategory' | translate }}</div>
                                        @if (isRestrictedCategoryResolution) {
                                            <af-dictionary-selector
                                                class="w-100 mt-4"
                                                [dictionary]="allowedCategoryDictionary"
                                                [control]="categoryControls[i]"
                                                [clearUnlistedValueOnOpen]="true"
                                                [unlistedValueLabel]="getCategoryName(categoryControls[i].value)"
                                                placeholder="i18n_af_placeholderSelectResolutionStatus">
                                            </af-dictionary-selector>
                                        } @else {
                                            <af-dictionary-selector
                                                class="w-100 mt-4"
                                                [dictionary]="getCategories(s.category)"
                                                [control]="categoryControls[i]"
                                                placeholder="i18n_af_placeholderSelectResolutionStatus">
                                            </af-dictionary-selector>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </ng-container>

                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                        <ui-kit-button spinnerId="createResolution"
                                       [label]="'i18n_af_buttonSave' | translate"/>
                        <ui-kit-button class="ml-16"
                                       color="accent"
                                       buttonType="button"
                                       type="text"
                                       (clickListener)="navigateBack()"
                                       [label]="'i18n_af_buttonCancel' | translate"/>
                    </div>
                </form>
            </div>
        </div>

    }
</af-main-container>
